var _rect, _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 15,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.994 11.5227C21.2338 10.702 20.1721 10.25 19.0002 10.25C17.8221 10.25 16.7569 10.6992 16.0002 11.5148C15.2354 12.3395 14.8627 13.4602 14.9502 14.6703C15.1237 17.0578 16.9405 19 19.0002 19C21.06 19 22.8737 17.0582 23.0498 14.6711C23.1385 13.4719 22.7635 12.3535 21.994 11.5227ZM25.8752 27.75H12.1252C11.9452 27.7523 11.767 27.7145 11.6035 27.6393C11.44 27.5641 11.2953 27.4534 11.1799 27.3152C10.926 27.0117 10.8237 26.5973 10.8994 26.1781C11.2291 24.3492 12.258 22.8129 13.8752 21.7344C15.3119 20.777 17.1319 20.25 19.0002 20.25C20.8686 20.25 22.6885 20.7773 24.1252 21.7344C25.7424 22.8125 26.7713 24.3488 27.101 26.1777C27.1768 26.5969 27.0744 27.0113 26.8205 27.3148C26.7052 27.4531 26.5605 27.5639 26.397 27.6391C26.2335 27.7144 26.0552 27.7523 25.8752 27.75Z",
    fill: "#6B7280"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    stroke: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/AvatarIcon.5d401bb4d96794a1ecd8f886a34927a5.svg";
export { ForwardRef as ReactComponent };